import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/bg-header-stt-should-del.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-right-white.svg'


const _hoisted_1 = {
  class: "flex flex-col px-0 bg-lp-white w-full",
  "data-testid": "incoming-sti-dest-header-stt-now-del"
}
const _hoisted_2 = { class: "flex text-gray-lp-300 font-semibold" }
const _hoisted_3 = {
  key: 0,
  class: "ml-1 mb-2 relative"
}
const _hoisted_4 = { class: "text-12px text-gray-lp-300" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "absolute bottom-0 right-0 size-full",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex flex-grow text-20px" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "flex flex-grow text-left content-center font-bold",
  style: {"font-size":"clamp(14px, 4vw, 50px)"}
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-grow"
}
const _hoisted_11 = {
  class: "text-left",
  style: {"font-size":"clamp(14px, 1vw, 16px)"}
}
const _hoisted_12 = {
  key: 2,
  class: "text-left font-semibold",
  style: {"font-size":"clamp(16px, 1vw, 20px)"}
}
const _hoisted_13 = {
  key: 3,
  class: "flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t("stiDest.dashboard.headerSttNowDel")) + " ", 1),
      (_ctx.statusChipsStyle)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("img", {
              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleStatusPanel($event, 'tooltipStatus'))),
              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleStatusPanel($event, 'tooltipStatus'))),
              src: 
            _ctx.toolTip1
              ? require('@/app/ui/assets/svg/info-red.svg')
              : require('@/app/ui/assets/svg/info.svg')
          ,
              alt: ""
            }, null, 40, ["src"]),
            _createVNode(_component_OverlayPanel, {
              ref: "tooltipStatus",
              appendTo: "body"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("stiDest.dashboard.tooltipSttAtConsolidator")), 1)
              ]),
              _: 1
            }, 512)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", {
      class: "relative flex flex-col flex-grow py-3 px-3 overflow-hidden text-white cursor-pointer",
      style: {"border-radius":"12px","background-image":"linear-gradient(90deg, #E13E49, #B82025)","height":"202px"},
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickCard && _ctx.onClickCard(...args)))
    }, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("stiDest.dashboard.totalStt")), 1),
        _hoisted_8
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.totalStt), 1))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode(_component_Skeleton, {
              height: "3rem",
              width: "100%"
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("stiDest.dashboard.intracityIntercity")), 1),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.formattedIntracity) + " / " + _toDisplayString(_ctx.formattedIntercity) + " STT ", 1))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _createVNode(_component_Skeleton, {
              height: "2rem",
              width: "100%"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}